import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { JSONRpc } from './service-jsonrpc';
import { Observable, of, observable, Subject, BehaviorSubject, ReplaySubject } from 'rxjs';

import { environment } from '../../environments/environment';
import { StateService} from './state.service';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class UtilitaryService {
    droits: any;
    constructor(
        private http: HttpClient
      ) {
      }
    log(...args){
        if(!environment.production){
            console.log(...args);
        }
    }
}